import { render } from "./facial-skin-age.vue?vue&type=template&id=83021fb0&scoped=true"
import script from "./facial-skin-age.vue?vue&type=script&lang=js"
export * from "./facial-skin-age.vue?vue&type=script&lang=js"

import "./facial-skin-age.vue?vue&type=style&index=0&id=83021fb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83021fb0"]])

export default __exports__